import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography,Popover,FormControlLabel,Checkbox,
  Tooltip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DataGrid } from '@mui/x-data-grid';
import { legalTeamApi } from '../../api/api';
import { useNavigate } from 'react-router-dom';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import IconButton from '@mui/material/IconButton';
const ApprovedProperty = () => {
  const user = useSelector((state) => state.user);
  const userId = user?.userId;
  const navigate = useNavigate();
  
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
   const [propertyTypeFilter, setPropertyTypeFilter] = useState("All");
   const [anchorEl, setAnchorEl] = useState(null);
   const handleIconClick = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleClose = () => {
  setAnchorEl(null);
};

  useEffect(() => {
    const getProperties = async () => {
      try {
        const response = await legalTeamApi.getLegalTeamPendingProperties(userId);
        const data = response.data;

        const formattedData = data.map((item) => ({
          ID: item.id,
          ApartmentId:item.ApartmentId,
          PropertyId:item.propertyId,
          UserName: item.UserName,
          ProjectId: item.ProjectId,
          ApartmentName:item.ApartmentName,
          ProjectName: item.project_name,
          PropertyName: item.PropertyName,
          City: item.City,
          Address: item.Address,
          SizeInSqFt: item.SizeInSqFt,
          SqFtPrice: item.SqFtPrice,
          Status: item.Status,
          PropertyPrice: item.PropertyPrice,
          NoOfPlots: item.NoOfPlots,
          IconUrl: item.IconUrl,
          PropertyType: item.PropertyType
        }));

        const statusOrder = {
          Pending: 1,
          Approved: 2,
          Inprogress: 3,
          Sold: 4,
        };

        const sortedData = formattedData.sort(
          (a, b) => statusOrder[a.Status] - statusOrder[b.Status]
        );

        setRows(sortedData);
        setFilteredRows(sortedData);
      } catch (error) {
        console.error('Error fetching properties:', error);
      }
    };

    getProperties();
  }, [userId]);
  const [pageSize, setPageSize] = useState(25);

  
const open = Boolean(anchorEl);
const id = open ? "column-popover" : undefined;

  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending':
        return 'blue';
      case 'Approved':
        return 'green';
      case 'InProgress':
        return 'orange';
      case 'Rejected':
        return 'red';
      default:
        return 'grey';
    }
  };

  const handleAction = (action, row) => {
   const routeMap = {
  approve: '/property/approveProperty',
};

if (routeMap[action]) {
  const id = row.PropertyType === 3 ? row.ApartmentId : row.PropertyId;

  navigate(`${routeMap[action]}?propertyId=${id}`, {
    state: {
      ...row,
       id:row.PropertyType === 3 ? row.ApartmentId :row.PropertyId
  
    },
  });
}


    
  if (action === "view") {
  if (row.PropertyType === "2" || row.PropertyType === "4") {
    // Navigate to property view
    navigate(`/property/viewProperty?propertyId=${row.PropertyId}`, {
      state: {
        PropertyId: row.PropertyId,
        PropertyName: row.PropertyName,
        City: row.City,
        PropertyType: row.PropertyType,
        ProjectName: row.ProjectName,
        Address: row.Address,
        SizeInSqFt: row.SizeInSqFt,
        UnitPrice: row.UnitPrice,
        IconUrl: row.IconUrl,
        InvestedUnit: row.InvestedUnit,
        TokenSize: row.TokenSize
      },
    });
  } else if (row.PropertyType === "1") {
    // Navigate to project view
    navigate(`/viewProject/viewProject?projectId=${row.ProjectId}`, {
      state: {
        ProjectId: row.ProjectId,
        ProjectName: row.ProjectName,
        City: row.City,
        Address: row.Address,
        IconUrl: row.IconUrl,
      },
    });
  }
  else if(row.PropertyType === "3") {
    navigate(`/apartment/viewApartment?propertyId=${row.ApartmentId}`,{
      state:{
         PropertyId: row.ApartmentId,
        ApartmentName:row.ApartmentName,
        PropertyName: row.PropertyName,
        City: row.City,
        PropertyType: row.PropertyType,
        Address: row.Address,
        SizeInSqFt: row.SizeInSqFt,
        IconUrl: row.IconUrl,
      }
    })
  }
}
  };

  // Apply filters
  useEffect(() => {
  let filtered = rows;

  // Filter by status
  if (statusFilter !== 'All') {
    filtered = filtered.filter((row) =>
      row.Status?.toLowerCase().includes(statusFilter.toLowerCase())
    );
  }

  // Filter by property type
  if (propertyTypeFilter !== 'All') {
    filtered = filtered.filter((row) =>
      row.PropertyType === parseInt(propertyTypeFilter)
    );
  }

  // Filter by keyword search
  if (searchTerm) {
    filtered = filtered.filter((row) =>
      Object.values(row)
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }

  setFilteredRows(filtered);
}, [statusFilter, searchTerm, propertyTypeFilter, rows]);

 const renderCellWithFallback = (params) => {
  return params.value === null || params.value === undefined || params.value === ''
    ? '------'
    : params.value;
};

  
  const columns = [
    { field: 'ID', headerName: 'ID', width: 70 ,renderCell:renderCellWithFallback},
    { field: 'UserName', headerName: 'Vendor Name', width: 180 ,renderCell:renderCellWithFallback},
    { field: 'ProjectName', headerName: 'Project Name', width: 180 ,renderCell:renderCellWithFallback},
    {field:'ApartmentName',headerName:'Apartment Name', width:200,renderCell:renderCellWithFallback},
    {
      field: 'PropertyName',
      headerName: 'Property Name',
      width: 200,
      renderCell: (params) => (
        <span
          style={{ color: 'blue', cursor: 'pointer' }}
          onClick={() => handleAction('approve', params.row)}
        >
          {params.value}
        </span>
      ),
    },
    {
  field: 'PropertyType',
  headerName: 'Property Type',
  width: 200,
  renderCell: (params) => {
    const typeMap = {
      1: 'Project',
      2: 'Property',
      3: 'Apartment',
      4: 'Individual Villa',
    };
    return typeMap[params.value] || 'Unknown';
  },
    },
    { field: 'City', headerName: 'City', width: 150 },
    { field: 'PropertyPrice', headerName: 'Property Value', width: 150 },
    { field: 'Address', headerName: 'Address', width: 250 },
    { field: 'SizeInSqFt', headerName: 'Size (SqFt)', width: 150 },
    { field: 'SqFtPrice', headerName: 'SqFt Price', width: 130 ,renderCell:renderCellWithFallback},
    {
      field: 'Status',
      headerName: 'Status',
      width: 130,
      renderCell: (params) => (
        <span
          style={{
            color: getStatusColor(params.value),
            fontWeight: 'bold',
            textTransform: 'capitalize',
          }}
        >
          {params.value}
        </span>
      ),
    },
   {
  field: 'actions',
  headerName: 'Actions',
  width: 120,
  renderCell: (params) => (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {/* View Icon */}
      <Tooltip title="View">
        <IconButton
          color="primary"
          onClick={() => handleAction('view', params.row)}
        >
          <VisibilityIcon />
        </IconButton>
      </Tooltip>

      {/* Approve Icon */}
      <Tooltip title="Approve">
        <span>
          <IconButton
            onClick={() => handleAction('approve', params.row)}
            sx={{ color: '#4CAF50' }}
            disabled={params.row.Status !== 'Pending'}
          >
            <CheckCircleIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  ),
}

  ];
   const [selectedFields, setSelectedFields] = useState(
  columns.map((col) => col.field)
);
const displayedColumns = columns.filter((col) =>
  selectedFields.includes(col.field)
);

  return (
    <Box p={2}>
      <Typography variant="h5" mb={2}>
        Property List
      </Typography>

      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Search by keywords"
            size='small'
            fullWidth
            variant="outlined"
            value={searchTerm}
            sx={{
              '& .MuiOutlinedInput-root':{
                  borderRadius:'15px'
              }
            }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Grid>
         <Grid item xs={6} sm={4} md={3}>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: '#ffffff',
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
                borderWidth: '2px',
              },
            },
          }}
        >
          <InputLabel sx={{ color: '#004d40', fontWeight: 'bold' }}>
            Type
          </InputLabel>
          <Select
            value={propertyTypeFilter}
            onChange={(e) => setPropertyTypeFilter(e.target.value)}
            label="Type"
            sx={{
              color: '#004d40',
              fontWeight: 500,
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  borderRadius: 2,
                  mt: 1,
                  backgroundColor: '#f9f9f9',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                  '& .MuiMenuItem-root': {
                    fontSize: '0.95rem',
                    '&:hover': {
                      backgroundColor: '#e0f2f1',
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="1">Project</MenuItem>
            <MenuItem value="2">Property</MenuItem>
            <MenuItem value="4">Individual Villa</MenuItem>
            <MenuItem value="3"> Apartment </MenuItem>
          </Select>
        </FormControl>
      </Grid>
       <Grid item xs={12} sm={3}>
  <FormControl fullWidth>
    <InputLabel>Status</InputLabel>
    <Select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      label="Status"
      size="small" // reduces the select box height
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 200, // limits dropdown height
            mt: 1,
            '& .MuiMenuItem-root': {
              minHeight: '30px',   // reduces item height
              fontSize: '0.85rem',
              paddingY: '4px',
            },
          },
        },
      }}
    >
      <MenuItem value="All">All</MenuItem>
      <MenuItem value="Pending">Pending</MenuItem>
      <MenuItem value="Approved">Approved</MenuItem>
      <MenuItem value="Rejected">Rejected</MenuItem>
      <MenuItem value="Sold">Sold</MenuItem>
    </Select>
  </FormControl>
</Grid>

      </Grid>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  <FormControl sx={{ minWidth: 120 }} size="small">
    <InputLabel id="page-size-label">Page Size</InputLabel>
    <Select
      labelId="page-size-label"
      id="page-size-select"
      value={pageSize}
      label="Page Size"
      onChange={(e) => setPageSize(Number(e.target.value))}
      sx={{ borderRadius: "15px" }}
    >
      <MenuItem value={25}>25</MenuItem>
      <MenuItem value={50}>50</MenuItem>
      <MenuItem value={100}>100</MenuItem>
      <MenuItem value={rows.length}>All</MenuItem>
    </Select>
  </FormControl>

  <IconButton onClick={handleIconClick}>
    <ViewColumnIcon />
  </IconButton>
</Box>


      <Box sx={{ height: 500, width: '100%', border: '1px solid #ccc', borderRadius: 2 }}>
        <DataGrid
          rows={filteredRows}
          columns={displayedColumns}
          pagination={false}
          getRowId={(row) => row.ID}
          disableSelectionOnClick
          autoHeight={false}
           sx={{
    border: '1px solid #ccc',
    borderRadius: 2,
    fontSize: '0.9rem',
    backgroundColor: '#fafafa',
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#e0f7fa',
    },
    '& .MuiDataGrid-cell': {
      color: '#333',
      borderBottom: '1px solid #ddd',
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#0e6eaf',
      color: 'white',
      fontWeight: 'bold',
    },
  }}
        />
      </Box>

        <Popover
  id={id}
  open={open}
  anchorEl={anchorEl}
  onClose={handleClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
>
  <Box sx={{ p: 2, maxWidth: 300 }}>
  <Typography variant="subtitle1" gutterBottom>
    Select Columns
  </Typography>
  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
    {columns.map((col) => (
      <FormControl 
        key={col.field} 
        component="fieldset"
        sx={{ m: 0, p: 0 }} // remove default margin and padding
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedFields.includes(col.field)}
              onChange={() => {
                setSelectedFields((prev) =>
                  prev.includes(col.field)
                    ? prev.filter((f) => f !== col.field)
                    : [...prev, col.field]
                );
              }}
              sx={{
                '&.Mui-checked': {
                  color: 'skyblue',
                },
              }}
            />
          }
          label={col.headerName}
          sx={{ m: 0 }}  // remove margin here as well
        />
      </FormControl>
    ))}
  </Box>
</Box>
</Popover>
    </Box>
  );
};

export default ApprovedProperty;
